import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, EMPTY } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../../base.component';
import { Account } from '../../../models/ui/account.model';
import { AccountManager } from '../../../managers/account.manager';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@Component({
    selector: 'lex-account-search',
    templateUrl: './account-search.component.html',
    styleUrls: ['./account-search.component.scss'],
    standalone: false
})
export class AccountSearchComponent extends BaseComponent implements OnInit {

	@ViewChild('searchBox') searchBoxElement: ElementRef;
	@ViewChild('leftScroll') leftScroll: CdkVirtualScrollViewport;
	@Input() selectedAccount: Account = null;
	@Output() selectedAccountChange: EventEmitter<Account> = new EventEmitter<Account>();
	@Input() selectedAccountId: string = null;
	@Input() source: string = '';

	private searchTerm = new BehaviorSubject<string>('');
	private searchText: string = '';

	public accounts: Account[] = [];

	constructor(
		private elementRef: ElementRef,
		private accountManager: AccountManager,
		private router: Router,
		private activatedRoute: ActivatedRoute) {
		super();
	}

	ngOnInit(): void {	this.searchTerm.pipe(
			debounceTime(500),
			distinctUntilChanged(),
			switchMap((term: string) => {
				this.searchText = term;
				if (this.selectedAccount) {
					this.getAccounts(this.source === 'manage-billing', this.selectedAccount.accountId);
				}
				else if (this.selectedAccountId) {
					this.getAccounts(this.source === 'manage-billing', this.selectedAccountId);
				}
				else {
					this.getAccounts(this.source === 'manage-billing');
				}
				return EMPTY;
			}),
			takeUntil(this.destroy$)
		).subscribe();
	}

	public getAccounts(isManageBilling: boolean, selectedAccountId?: string): void {
		this.accountManager.getManagedAccounts(isManageBilling, this.searchText).subscribe(data => {
			this.accounts = data;
			if (data.length === 1) {
				this.selectedAccount = data[0];
				this.selectedAccountChange.emit(this.selectedAccount);
			}
			else if (selectedAccountId) {
				this.selectedAccount = this.accounts.find(x => x.accountId === selectedAccountId);
				this.selectedAccountChange.emit(this.selectedAccount);
				if (this.selectedAccount)
					setTimeout(() => this.leftScroll.scrollToIndex(data.indexOf(this.selectedAccount)));
			}
			else
				this.selectedAccount = null;
		});
	}

	public selectAccount(account: Account): void {
		this.selectedAccount = account;
		this.selectedAccountChange.emit(this.selectedAccount);
		this.router.navigate([], { relativeTo: this.activatedRoute });
	}

	public updateSearchText(term: string): void {
		this.searchTerm.next(term);
	}
}
